export const MenuItems = [
    {
      title: 'Cambridge Chronicles 🎓',
      path: '/cambridge',
      cName: 'dropdown-link'
    },
    {
      title: 'Mad Badgers 🦡',
      path: '/madison',
      cName: 'dropdown-link'
    }
];